import { api } from './api';
import type { Role } from '@apptypes/index';

export const adminService = {
  checkSuperAdmin: () =>
    api.get<{ superAdmin: boolean }>('/admin/me/super-admin'),
};

export const rolesService = {
  list: () =>
    api.get<Role[]>('/admin/roles'),

  get: (roleId: string) =>
    api.get<Role>(`/admin/roles/${roleId}`),

  create: (data: { name: string; description?: string }) =>
    api.post<Role>('/admin/roles', data),

  update: (roleId: string, data: { name?: string; description?: string }) =>
    api.put<Role>(`/admin/roles/${roleId}`, data),

  delete: (roleId: string) =>
    api.delete(`/admin/roles/${roleId}`),

  setPermissions: (roleId: string, permissionIds: string[]) =>
    api.put<Role>(`/admin/roles/${roleId}/permissions`, { permissionIds }),
};
